import makeCurrentDayAvailability from './makeCurrentDayAvailability'
import appointmentFilter from './appointmentFilter'

export default function getDisabled(date, calendar, availability) {
  const currentDayAvailability = makeCurrentDayAvailability(availability, date)
  const [includedHours, includedMinutes] = appointmentFilter(currentDayAvailability, Object.values(calendar), date)

  return [() => includedHours, includedMinutes]
}
